module.exports = __webpack_public_path__ + "svg/edit.svg?34ed9a32505c51544dfba408dc3a71e0";